module.exports = __webpack_public_path__ + "static/media/38_tn.50cc7536.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/38_tn.jpg
// module id = 526
// module chunks = 0